module.exports = __webpack_public_path__ + "img/press-sq.ec71d62f.png";